import { valueof } from '.';

export const BANNER_TYPE = {
  INFORMATION: 'Information',
  WARNING: 'Warning',
  SUCCESS: 'Success',
  ERROR: 'Error'
} as const;

export type BannerKindType = valueof<typeof BANNER_TYPE>;
